import {
    ToolbarButton,
    QuickFilter,

} from '@mui/x-data-grid-pro'
import {
    styled,
} from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import {
    DEFAULT_EXPANDED_INPUT_WIDTH,
} from './QuickFilterToolbarItem'

export const StyledQuickFilter = styled(QuickFilter)({
    display: 'grid',
    alignItems: 'center',
})
export const StyledWrapper = styled('div')({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
})

type OwnerState = {
    expanded: boolean
}

export const StyledToolbarButton = styled(ToolbarButton)<{ ownerState: OwnerState }>(
    ({
        theme, ownerState,
    }) => {
        return {
            gridArea: '1 / 1',
            width: 'min-content',
            height: 'min-content',
            zIndex: 1,
            opacity: ownerState.expanded ? 0 : 1,
            pointerEvents: ownerState.expanded ? 'none' : 'auto',
            transition: theme.transitions.create(['opacity']),
        }
    },
)

export const StyledTextField = styled(TextField)<{
    ownerState: OwnerState & { maxWidth: number };
}>(({
    theme, ownerState,
}) => {
    const expandedWidth = ownerState.maxWidth > DEFAULT_EXPANDED_INPUT_WIDTH
        ? DEFAULT_EXPANDED_INPUT_WIDTH
        : ownerState.maxWidth

    return {
        gridArea: '1 / 1',
        overflowX: 'clip',
        width: ownerState.expanded ? expandedWidth : 'var(--trigger-width)',
        maxWidth: `${expandedWidth}px`,
        opacity: ownerState.expanded ? 1 : 0,
        transition: theme.transitions.create([
            'width',
            'opacity',
        ]),
        '& .MuiInputBase-root': {
            height: '30px',
        },
    }
})
